// extracted by mini-css-extract-plugin
export default {"Wrapper":"ButtonAdd_Wrapper__35LkI","Button":"ButtonAdd_Button__3Ir-x","Add":"ButtonAdd_Add__vAGVh"};